export default __webpack_public_path__ + "static/ferrara_04-7951ce423b2d523c6f115a3d5a1cd967.jpg";